import { useState } from 'react'
import { httpsCallable } from 'firebase/functions'
import { isFirebaseConfigured, requireFunctions } from '../lib/firebase'
import { errorMessage } from '../lib/useAuth'
import { useT } from '../i18n'
import { track } from '../lib/analytics'

/**
 * Achat unique. La session Stripe est créée côté serveur : le prix, la devise et
 * le produit ne transitent jamais par le navigateur, où ils seraient modifiables.
 */
interface Props {
  className?: string
  label?: string
}

export default function BuyButton({ className = 'btn btn-primary', label }: Props) {
  const t = useT()
  const text = label ?? t.pricing.buy
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function buy() {
    setBusy(true)
    setError(null)
    try {
      track('begin_checkout')
      const call = httpsCallable<void, { url: string }>(requireFunctions(), 'createCheckoutSession')
      const { data } = await call()
      window.location.href = data.url
    } catch (e) {
      setError(errorMessage(e))
      setBusy(false)
    }
  }

  if (!isFirebaseConfigured) {
    return <span className={className} aria-disabled="true">{text}</span>
  }

  return (
    <>
      <button className={className} onClick={buy} disabled={busy}>
        {busy ? t.pricing.buyBusy : text}
      </button>
      {error && <p className="alert is-error" style={{ marginTop: '.8rem' }}>{error}</p>}
    </>
  )
}
